module.exports = {
	"annoyingEmail": "Vous ne voulez plus recevoir ces courriels?",
	"clickButton": "Pour ce faire, vous avez simplement à cliquer sur le bouton ci-dessous.",
	"hi": "Bonjour",
	"niceDay": "Merci et bonne journée!",
	"unsubscribe": "Se désinscrire"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/emailTemplate.json5
// module id = 1980
// module chunks = 6